export default "__VITE_ASSET__1T$dlBME__"